import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

/* Types & Action Creators */

const { Types, Creators } = createActions({
  signInRequest: ["email", "password"],
  signInSuccess: ["token", "user"],
  getUser: [""],
  getUserSuccess: ["user"],
  logout: [""]
});

export const AuthTypes = Types;
export default Creators;

/* Initial State */

export const INITIAL_STATE = Immutable({
  signedIn: !!localStorage.getItem("@chat-app:token"),
  token: localStorage.getItem("@chat-app:token") || null,
  user: {}
});

/* Reducers */

export const success = (state, { token, user }) =>
  state.merge({ signedIn: true, user });

export const getUserSuccess = (state, { user }) => state.merge({ user });

export const logout = (state, { token }) =>
  state.merge({ signedIn: false, user: {} });

/* Reducers to types */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SIGN_IN_SUCCESS]: success,
  [Types.GET_USER_SUCCESS]: getUserSuccess,
  [Types.LOGOUT]: logout
});



// WEBPACK FOOTER //
// ./src/storeChat/ducks/auth.js